import createClient from '../../helpers/api-client';

const storeSuffix = 'Rating';

// Actions
export const SEND_RATING_FOR_REQUEST_ID = `sendRatingForRequestIDAction${storeSuffix}`;
export const SEND_ANSWER_FOR_ID = `sendAnswerForIDAction${storeSuffix}`;

// Mutations
export const SET_COMPANYID = `setComapnyIdMutation${storeSuffix}`;
export const SET_RATING = `setRatingMutation${storeSuffix}`;
export const SET_TITLE = `setTitleMutation${storeSuffix}`;
export const SET_MESSAGE = `setMessageMutation${storeSuffix}`;
export const SET_SIGNATURE = `setSignatureMutation${storeSuffix}`;
export const SET_ANSWER = `setAnsweMutation${storeSuffix}`;
export const BEGIN_REQUEST = `beginRequestMutation${storeSuffix}`;
export const REQUEST_DONE = `requestDoneMutation${storeSuffix}`;
export const REQUEST_ERROR = `requestErrorMutation${storeSuffix}`;

// Getters
export const GET_CONTENT = `getContentGetter${storeSuffix}`;
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;

export const modelState = () => ({
    rating: {
        isLoading: true,
        error: false,
        data: {
            CompanyId: null,
            Rating: 0,
            Title: '',
            Comment: '',
            Signature: '',
            Answer: '',
        },
    },
});

export const actions = {
    [SEND_RATING_FOR_REQUEST_ID]: ({ state, commit }, requestId) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_REQUEST);

            try {
                const data = {
                    RequestId: requestId,
                    ...state.rating.data,
                };

                const res = await apiClient.post(`/api/ratings/rate`, data);

                commit(REQUEST_DONE);

                resolve(res);
            } catch (error) {
                commit(REQUEST_ERROR, {
                    error,
                });
                console.log(error);
                reject(error);
            }
        });
    },
    [SEND_ANSWER_FOR_ID]: ({ state, commit }, ratingId) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_REQUEST);

            try {
                const res = await apiClient.post(
                    `/api/rating/${ratingId}/answer`,
                    state.rating.data
                );

                commit(REQUEST_DONE);

                resolve(res);
            } catch (error) {
                commit(REQUEST_ERROR, {
                    error,
                });
                console.log(error);
                reject(error);
            }
        });
    },
};

export const mutations = {
    [SET_COMPANYID]: (state, companyId) => {
        state.rating.data.CompanyId = companyId;
    },
    [SET_RATING]: (state, rating) => {
        state.rating.data.Rating = rating;
    },
    [SET_TITLE]: (state, title) => {
        state.rating.data.Title = title;
    },
    [SET_MESSAGE]: (state, comment) => {
        state.rating.data.Comment = comment;
    },
    [SET_SIGNATURE]: (state, signature) => {
        state.rating.data.Signature = signature;
    },
    [SET_ANSWER]: (state, answer) => {
        state.rating.data.Answer = answer;
    },
    [BEGIN_REQUEST]: state => {
        state.rating.isLoading = true;
        state.rating.error = false;
    },
    [REQUEST_DONE]: state => {
        state.rating.isLoading = false;
        state.rating.error = false;
    },
    [REQUEST_ERROR]: (state, payload) => {
        state.rating.isLoading = false;
        state.rating.error = true;
    },
};

export const getters = {
    [GET_CONTENT]: state => {
        return state.rating.data;
    },
    [IS_LOADING]: state => {
        return state.rating.isLoading;
    },
    [GET_ERROR]: state => {
        return state.rating.error;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/rating-model.js